import http from '../utils/http';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

const defaultState = {
    entityName: 'jobs',
    baseUrl: 'api/jobs/',
    tableName: 'jobsTable',
    ...baseState,
    tableFieldsTasks: [
        { text: 'Date', value: 'createdAt', sortable: true },
        { text: 'Entity', value: 'entity', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Code', value: 'content.statusCode', sortable: false },
        { text: 'Message', value: 'content.message', sortable: false }
    ],
    computedFieldsTasks: [
        { computed: 'localeDateTime', value: 'createdAt' },
        { computed: 'shortenValue', value: 'content.message' }
    ],
    jobTasks: {}
};

export const mutations = {
    ...baseMutations,
    setJobTasks(state, value) {
        if (value) {
            state.jobTasks = value;
        } else {
            state.jobTasks = {};
        }
    }
};

export const actions = {
    ...baseActions,
    fetchJobs({ commit, dispatch, state }, { searchParams, filterParams }) {
        console.log('calling fetchJobs', searchParams, filterParams);
        const notifyConfig = {
            notifyRequestPending: true
        };
        return dispatch('fetchItems', {
            searchParams,
            filterParams,
            notifyConfig,
            saveParams: true,
            isDsSearch: false
        }).then(res => {
            const { content, ...page } = res.data;
            commit('setItems', content);
            commit('setResponseQuery', { ...page });
            commit('setRequestQuery', {
                ...state.requestQuery,
                size: page.size,
                number: page.number
            });
        });
    },
    fetchJobTasks({ commit, state }, { jobId }) {
        console.log('calling fetchJobTasks', jobId);
        return http
            .get(`${state.baseUrl}${jobId}`, {
                notifyRequestPending: true
            })
            .then(res => {
                commit('setJobTasks', res.data);
            });
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
